import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64b1d4e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = { class: "row-fields-6" }
const _hoisted_3 = { class: "controls-container" }
const _hoisted_4 = { class: "toggle-container" }
const _hoisted_5 = { class: "grid-menu" }
const _hoisted_6 = { class: "email-items-header-container" }
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = { class: "row-fields-2" }
const _hoisted_9 = { class: "found-total-container" }
const _hoisted_10 = { class: "found-total-container" }
const _hoisted_11 = { class: "tab-container" }

import { computed, onMounted, PropType, ref, watch } from "vue";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import GridMenu from "@/components/ui/grid/grid-menu.vue";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import AcquaintDateBox from "@/components/ui/inputs/acquaint-date-box.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import CurrencyInfoBox from "@/components/ui/inputs/currency-info-box.vue";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import { useFinancialHelper } from "@/utils/financials/useFinancialHelper";
import { TransactionsValidation } from "acquaint-api/validation/TransactionsValidation";
import moment from "moment";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import { FinancialDefaults } from "@/utils/financials/FinancialDefaults";
import { sleep } from "@/utils/system/TimeoutHelper";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import {
  AccountItem,
  ConsolidatedPaymentFormItem,
  ConsolidatedPaymentRunModalProps,
  ConsolidatedToPayItem,
  PayAccountRequest,
} from "@/types/financials/ConsolidatedPayment";
import {
  PaymentExportFormat,
  PaymentMethod,
} from "@/enums/tenancies/PaymentMethod";
import ConsolidatedPaymentStep2 from "@/components/financials/consolidated-payment-step2.vue";
import { useContactHelper } from "@/utils/contacts/useContactHelper";
import { PreferredDeliveryMethod } from "@/enums/financials/ContactType";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import ConsolidatedPaymentGrid from "@/components/financials/consolidated-payment-grid.vue";
import { BankAccountType } from "@/enums/accounts/AccountEnums";


export default /*#__PURE__*/_defineComponent({
  __name: 'consolidated-payment-run-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * Additional props to be passed to the Consolidated Payment Run modal.
   * Allows customization of the inner modal's behavior and appearance.
   * @type {ConsolidatedPaymentRunModalProps}
   * @default undefined
   */
  modalProps: {
    type: Object as PropType<ConsolidatedPaymentRunModalProps>,
    default: undefined,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const contactHelper = useContactHelper();
const systemConfigurationStore = useSystemConfigurationStore();
const financialHelper = useFinancialHelper();
const gridCredits = ref<ConsolidatedToPayItem[]>([]);
const consolidatedPaymentPostingList = ref<ConsolidatedToPayItem[]>([]);
const consolidatePaymentEmailList = ref<ConsolidatedToPayItem[]>([]);
const formItem = ref<ConsolidatedPaymentFormItem>(
  FinancialDefaults.defaultConsolidatedPaymentFormItem(),
);
const contextMenuId = `action-button-${Math.floor(Math.random() * 1000)}`;
const mbooRun = ref(false);
const mdatRunDateTime = ref("");
const modalKey = ref(0);
const selectedTab = ref(0);
const loading = ref(false);
const maxDate = ref(moment().add(9, "days").endOf("day").toDate());
const paymentExportFileFormat = ref(-1);
const allowUnclearedFundsPayments = ref(-1);
const defaultMakePaymentsPaymentMethod = ref(-1);
const defaultPaymentRunDateXDaysInFuture = ref(-1);
const paymentGridRef = ref();
const toBePaidCount = ref(0);
const totalToBePaid = ref(0);
const mintPaymentCount = ref(0);
const mdecPayments = ref(0);
const isModalOpened = ref(false);

onMounted(async () => {
  paymentExportFileFormat.value = parseInt(
    await systemConfigurationStore.getSystemConfigurationValue(
      SystemConfiguration.PaymentExportFileFormat,
    ),
  );

  allowUnclearedFundsPayments.value = parseInt(
    await systemConfigurationStore.getSystemConfigurationValue(
      SystemConfiguration.AllowUnclearedFundsPayments,
    ),
  );

  defaultMakePaymentsPaymentMethod.value = parseInt(
    await systemConfigurationStore.getSystemConfigurationValue(
      SystemConfiguration.DefaultMakePaymentsPaymentMethod,
    ),
  );

  defaultPaymentRunDateXDaysInFuture.value = parseInt(
    await systemConfigurationStore.getSystemConfigurationValue(
      SystemConfiguration.DefaultPaymentRunDateXDaysInFuture,
    ),
  );
});

const storePaymentRunData = () => {
  const selectedItems = gridCredits.value.filter(
    (item) => item.include === true,
  );
  const paymentRunData = selectedItems.map((item) => ({
    contactId: item.contactId,
    referenceChequeNo: item.referenceChequeNo || "",
  }));

  localStorage.setItem(
    "consolidatedPaymentRunData",
    JSON.stringify(paymentRunData),
  );
};

watch(
  [() => showModal.value, () => props.modalProps],
  async ([newModal, newModalProps]) => {
    if (!newModal) {
      isModalOpened.value = false;
      return;
    }

    modalKey.value++;
    mbooRun.value = false;
    formItem.value = FinancialDefaults.defaultConsolidatedPaymentFormItem();
    formItem.value.paymentMethodId = defaultMakePaymentsPaymentMethod.value;

    // Default the payment date to x days in the future
    formItem.value.paymentDate = moment()
      .add(defaultPaymentRunDateXDaysInFuture.value, "days")
      .format("YYYY-MM-DD");

    formItem.value.paymentExportFormat = paymentExportFileFormat.value;
    formItem.value.bankAccountId = BankAccountType.Client;
    formItem.value.allowUnclearedFundsPayments =
      allowUnclearedFundsPayments.value;

    if (newModalProps) {
      formItem.value.siteId = newModalProps.siteId;
      formItem.value.contactId = newModalProps.contactId;
      formItem.value.bankAccountId = newModalProps.bankAccountId;
    }

    selectedTab.value = 0;
    await sleep(300);
    isModalOpened.value = true;
  },
);

watch(
  () => gridCredits.value,
  () => {
    toBePaidCount.value = gridCredits.value.length;
    totalToBePaid.value = 0;
    for (const item of gridCredits.value) {
      totalToBePaid.value += item.amountToPay;
    }
  },
  { deep: true },
);

const onPaymentMethodChange = () => {
  if (
    formItem.value.paymentMethodId === PaymentMethod.StandingOrder ||
    formItem.value.paymentMethodId === PaymentMethod.AccountTransfer ||
    formItem.value.paymentMethodId === PaymentMethod.CreditCard
  ) {
    if (paymentExportFileFormat.value > PaymentExportFormat.Generic) {
      formItem.value.onlyIncludeWithBankAccounts = true;
    }
  } else {
    formItem.value.onlyIncludeWithBankAccounts = false;
  }
};

const onSpecialContactChange = async () => {
  await sleep(300);
  paymentGridRef.value.specialContactChanged();
};

const onBranchChange = async () => {
  await sleep(300);
  paymentGridRef.value.branchChanged();
};

const onBankAccountChange = async () => {
  await sleep(300);
  paymentGridRef.value.bankAccountChanged();
};

const onPaymentExportFormatChange = async () => {
  await sleep(300);
  paymentGridRef.value.paymentExportFormatChanged();
};

const onOnlyIncludeWithBankAccounts = async () => {
  await sleep(300);
  paymentGridRef.value.onlyIncludeWithBankAccountsChanged();
};

const process = async () => {
  try {
    loading.value = true;
    // Disable Payment Summary Report button as this won't work after the Run process has completed
    formItem.value.paymentSummaryReportAvailable = false;

    // Disable run and refresh buttons as this can cause contacts to be paid incorrectly or multiple times
    formItem.value.butMenuEnabled = false;
    formItem.value.butRunEnabled = false;

    // Enable/disable other controls to avoid errors
    formItem.value.landlordEnable = false;
    formItem.value.paymentMethodEnable = false;
    formItem.value.paymentDateEnable = false;
    formItem.value.chkBankAccountEnable = false;
    formItem.value.creditsEnable = false;
    formItem.value.siteEnable = false;
    formItem.value.bankAccountEnable = false;
    formItem.value.paymentExportFormatEnable = false;
    formItem.value.butExitEnabled = false;

    const request: PayAccountRequest = {
      bankAccountId: formItem.value.bankAccountId,
      bankAccountName: "sample string 2",
      paymentDate: formItem.value.paymentDate,
      processingDate: formItem.value.processingDate,
      paymentExportFormat: formItem.value.paymentExportFormat,
      paymentMethodId: formItem.value.paymentMethodId,
      accounts: accountItems.value,
    };

    const paymentAccountItem =
      await financialHelper.payConsolidatedAccounts(request);
    if (paymentAccountItem) {
      formItem.value.paymentRunId = paymentAccountItem.paymentRunId;
      formItem.value.accountStatements = paymentAccountItem.accountStatements;
      formItem.value.paymentRunExportFileName =
        paymentAccountItem.paymentRunExportFileName;
    }

    mbooRun.value = true;
    mdatRunDateTime.value = moment().format("YYYY-MM-DD HH:mm:ss");
    updateStep2Counts();
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  } finally {
    formItem.value.butExitEnabled = true;
    loading.value = false;
  }
};

const includedItems = computed(() => {
  return gridCredits.value.filter((item) => item.include);
});

const accountItems = computed<AccountItem[]>(() => {
  return includedItems.value.map((item) => ({
    contactId: item.contactId,
    taxDeduction: item.taxToDeduct,
    referenceChequeNo: item.referenceChequeNo,
    amountToPay: item.amountToPay,
    balance: item.balance,
    invoiceFeesSeparately: item.invoiceFeesSeparately,
    invoiceFeesTotal: item.invoiceFeesTotal,
  }));
});

const contactIds = computed<number[]>(() => {
  return includedItems.value.map((item) => item.contactId);
});

watch(
  () => includedItems.value,
  () => {
    mintPaymentCount.value = 0;
    mdecPayments.value = 0;
    for (const item of includedItems.value) {
      mintPaymentCount.value++;
      mdecPayments.value += item.amountToPay;
    }

    if (mintPaymentCount.value > 0) {
      formItem.value.paymentSummaryReportAvailable = true;
      formItem.value.butRunEnabled = true;
    } else {
      formItem.value.paymentSummaryReportAvailable = false;
      formItem.value.butRunEnabled = false;
    }
  },
  { deep: true },
);

const updateStep2Counts = async () => {
  let intEmailCount = 0;
  let intPostCount = 0;
  consolidatePaymentEmailList.value = [];
  consolidatedPaymentPostingList.value = [];

  for (const item of includedItems.value) {
    const contactItem = await contactHelper.fetchContactById(item.contactId);

    if (contactItem) {
      const hasEmail = contactItem.email && contactItem.email !== "";
      const method = contactItem.preferredDeliveryMethod;

      if (formItem.value.preferredDeliveryMethod) {
        if (hasEmail) {
          if (
            method === PreferredDeliveryMethod.Email ||
            method === PreferredDeliveryMethod.EmailPrint
          ) {
            intEmailCount++;
            consolidatePaymentEmailList.value = [
              ...consolidatePaymentEmailList.value,
              item,
            ];
          }
          if (
            method === PreferredDeliveryMethod.Print ||
            method === PreferredDeliveryMethod.EmailPrint
          ) {
            intPostCount++;
            consolidatedPaymentPostingList.value = [
              ...consolidatedPaymentPostingList.value,
              item,
            ];
          }
        } else {
          // No so posted only
          intPostCount++;
        }
      } else {
        intPostCount++;
        if (hasEmail) {
          intEmailCount++;
        }
      }
    }
  }

  formItem.value.statementsFiling = includedItems.value.length;
  formItem.value.statementsPosting = intPostCount;
  formItem.value.statementsEmail = intEmailCount;
  formItem.value.enableButPrintForFiling = true;

  if (intPostCount > 0) {
    formItem.value.enableButPrintForPosting = true;
  } else {
    formItem.value.enableButPrintForPosting = false;
  }

  if (intEmailCount > 0) {
    formItem.value.enableButEmail = true;
  } else {
    formItem.value.enableButEmail = false;
  }

  formItem.value.enablePreferredDeliveryMethod = true;
  formItem.value.enableButPaymentExportFile = true;

  selectedTab.value = 1;
};

const onRunClick = async () => {
  const question = await displayQuestionAlert(
    "Are you sure you want to do this?",
  );

  if (question.isConfirmed) {
    storePaymentRunData();
    await process();
  }
};

const onExitClick = async () => {
  if (mbooRun.value) {
    const question = await displayQuestionAlert(
      "Were your Statements correct and have they been successfully produced?",
    );
    if (!question.isConfirmed && formItem.value.paymentRunId > 0) {
      await financialHelper.undoPaymentRuns(formItem.value.paymentRunId);
    }
  }
  showModal.value = false;
};
const menuItems = computed(() => {
  const menu: ContextMenuItem[] = [];
  //if (payButtonState.value.showPayCredit) {
  menu.push(
    {
      text: "Tick All",
      key: "tickAll",
      disabled: false,
      icon: "far fa-square-check",
    },
    {
      text: "Untick All",
      key: "untickAll",
      disabled: false,
      icon: "far fa-square",
    },
  );
  if (formItem.value.paymentSummaryReportAvailable) {
    menu.push({
      text: "Payment Summary Report",
      key: "paymentSummaryReport",
      disabled: false,
      icon: "far fa-bar-chart",
    });
  }
  //}
  menu.push(
    {
      text: "Set Float Amount",
      key: "setFloatAmount",
      disabled: false,
      icon: "far fa-gear",
    },
    {
      text: "Pause/Unpause Payments",
      key: "pauseUnpausePayments",
      disabled: false,
      icon: "far fa-circle-pause",
    },
    {
      text: "Export Grid to Excel",
      key: "exportToExcel",
      disabled: false,
      icon: "fas fa-download",
    },
    {
      text: "Refresh",
      key: "refresh",
      disabled: false,
      icon: "fas fa-redo",
    },
  );

  return menu;
});

const onMenuItemClicked = async (key: string) => {
  if (!paymentGridRef.value) return;

  switch (key) {
    case "tickAll":
      paymentGridRef.value.tickAll();
      break;
    case "untickAll":
      paymentGridRef.value.untickAll();
      break;
    case "paymentSummaryReport":
      await paymentGridRef.value.paymentSummaryReport();
      break;
    case "setFloatAmount":
      paymentGridRef.value.setFloatAmount();
      break;
    case "pauseUnpausePayments":
      await paymentGridRef.value.pauseUnpausePayments();
      break;
    case "exportToExcel":
      paymentGridRef.value.exportToExcel();
      break;
    case "refresh":
      paymentGridRef.value.refresh();
      break;
    default:
      break;
  }
};

const onStep2FormItemUpdate = async (newItem: ConsolidatedPaymentFormItem) => {
  formItem.value = newItem;
  await updateStep2Counts();
};

const modalClosed = () => {
  showModal.value = false;
};

const onGridCreditsUpdate = (newItems: ConsolidatedToPayItem[]) => {
  gridCredits.value = [...newItems];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showModal).value = $event)),
    title: "Consolidated Payment Run",
    height: '780',
    width: _unref(ModalWidth).XLarge,
    onModalClosed: modalClosed
  }, {
    content: _withCtx(() => [
      _createVNode(_unref(DxTabPanel), {
        "scroll-by-content": true,
        "show-nav-buttons": true,
        "swipe-enabled": false,
        selectedIndex: selectedTab.value,
        "onUpdate:selectedIndex": _cache[7] || (_cache[7] = ($event: any) => ((selectedTab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxItem), { title: "Step 1" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _createVNode(LookupSingleSelect, {
                      label: "Payment Method",
                      modelValue: formItem.value.paymentMethodId,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((formItem.value.paymentMethodId) = $event)),
                        onPaymentMethodChange
                      ],
                      "read-only": !formItem.value.paymentMethodEnable,
                      lookupSource: _unref(LookupTableSource).PaymentMethods
                    }, null, 8, ["modelValue", "read-only", "lookupSource"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(LookupSingleSelect, {
                      label: "Branch",
                      modelValue: formItem.value.siteId,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((formItem.value.siteId) = $event)),
                        onBranchChange
                      ],
                      "lookup-source": _unref(LookupTableSource).Sites,
                      "read-only": !formItem.value.siteEnable,
                      displayAllOption: true,
                      allowZeroValue: true
                    }, null, 8, ["modelValue", "lookup-source", "read-only"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(LookupSingleSelect, {
                      label: "Account",
                      modelValue: formItem.value.bankAccountId,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((formItem.value.bankAccountId) = $event)),
                        onBankAccountChange
                      ],
                      "read-only": !formItem.value.bankAccountEnable,
                      "lookup-source": _unref(LookupTableSource).BankAccounts
                    }, null, 8, ["modelValue", "read-only", "lookup-source"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(SystemCodeSingleSelect, {
                      label: "Payment Export Format",
                      "code-type": _unref(CodeType).PaymentExportFileFormat,
                      modelValue: formItem.value.paymentExportFormat,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((formItem.value.paymentExportFormat) = $event)),
                        onPaymentExportFormatChange
                      ],
                      "read-only": !formItem.value.paymentExportFormatEnable
                    }, null, 8, ["code-type", "modelValue", "read-only"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(AcquaintDateBox, {
                      label: "Payment Date",
                      modelValue: formItem.value.paymentDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formItem.value.paymentDate) = $event)),
                      readOnly: !formItem.value.paymentDateEnable,
                      fieldValidation: _unref(TransactionsValidation).DueDate,
                      requiredInput: false,
                      displayAsterisk: false,
                      maxDate: maxDate.value
                    }, null, 8, ["modelValue", "readOnly", "fieldValidation", "maxDate"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createVNode(ContactLookup, {
                      modelValue: formItem.value.contactId,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((formItem.value.contactId) = $event)),
                        onSpecialContactChange
                      ],
                      label: "Specific Contact",
                      "read-only": !formItem.value.landlordEnable,
                      showClearIcon: true
                    }, null, 8, ["modelValue", "read-only"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(SwitchToggle, {
                      label: "Only Include With Bank Accounts",
                      modelValue: formItem.value.onlyIncludeWithBankAccounts,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((formItem.value.onlyIncludeWithBankAccounts) = $event)),
                        onOnlyIncludeWithBankAccounts
                      ],
                      "read-only": !formItem.value.chkBankAccountEnable
                    }, null, 8, ["modelValue", "read-only"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(), _createBlock(GridMenu, {
                          key: contextMenuId,
                          "menu-items": menuItems.value,
                          "button-icon": "fas fa-bars",
                          id: contextMenuId,
                          disabled: !formItem.value.butMenuEnabled,
                          onItemClicked: onMenuItemClicked
                        }, null, 8, ["menu-items", "disabled"]))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  (isModalOpened.value)
                    ? (_openBlock(), _createBlock(ConsolidatedPaymentGrid, {
                        ref_key: "paymentGridRef",
                        ref: paymentGridRef,
                        key: modalKey.value,
                        "form-item": formItem.value,
                        loading: loading.value,
                        "read-only": !formItem.value.creditsEnable,
                        isModalOpened: isModalOpened.value,
                        onUpdateGridCredits: onGridCreditsUpdate
                      }, null, 8, ["form-item", "loading", "read-only", "isModalOpened"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createVNode(AcquaintInfoBox, {
                        label: "Payments Found",
                        text: toBePaidCount.value.toString()
                      }, null, 8, ["text"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(CurrencyInfoBox, {
                        label: " ",
                        value: totalToBePaid.value
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createVNode(AcquaintInfoBox, {
                        label: "Selected Payment Total",
                        text: mintPaymentCount.value.toString()
                      }, null, 8, ["text"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(CurrencyInfoBox, {
                        label: " ",
                        value: mdecPayments.value
                      }, null, 8, ["value"])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(DxItem), { title: "Step 2" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                (isModalOpened.value)
                  ? (_openBlock(), _createBlock(ConsolidatedPaymentStep2, {
                      key: 0,
                      "form-item": formItem.value,
                      "contact-ids": contactIds.value,
                      "onUpdate:formItem": onStep2FormItemUpdate
                    }, null, 8, ["form-item", "contact-ids"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selectedIndex"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          disabled: !formItem.value.butRunEnabled,
          text: 'Run',
          onClick: () => {
            onRunClick();
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Exit',
          disabled: !formItem.value.butExitEnabled,
          onClick: () => {
            onExitClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})